import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { MsrpComponent } from './components/msrp/msrp.component';
import { PaymentScheduleComponent } from './components/payment-schedule/payment-schedule.component';
import { QuoteCardsComponent } from './components/quote-cards/quote-cards.component';
import { QuoteSummaryHeaderComponent } from './components/quote-summary-header/quote-summary-header.component';
import { QuoteSummaryComponent } from './components/quote-summary/quote-summary.component';
import { ReviewQuoteComponent } from './components/review-quote/review-quote.component';
import { WrapArticleComponent } from './components/wrap-article/wrap-article.component';
import { WrapSectionComponent } from './components/wrap-section/wrap-section.component';

@NgModule({
  declarations: [
    PaymentScheduleComponent,
    WrapArticleComponent,
    WrapSectionComponent,
    QuoteSummaryComponent,
    QuoteSummaryHeaderComponent,
    ReviewQuoteComponent,
    QuoteCardsComponent,
    MsrpComponent
  ],
  exports: [
    PaymentScheduleComponent,
    WrapArticleComponent,
    WrapSectionComponent,
    QuoteSummaryComponent,
    QuoteSummaryHeaderComponent,
    QuoteCardsComponent,
    ReviewQuoteComponent,
    MsrpComponent
  ],
  imports: [CommonModule, UiKitModule, SharedServicesModule, FormsModule, ReactiveFormsModule],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class PolicySharedModule {}
